/**
 * Kpathport 관련 경로 상수
 * 모든 Kpathport 관련 경로를 중앙에서 관리
 */

export const KPATHPORT_ROUTES = {
  // 메인 페이지 (Discover, MyRewards는 비활성화됨 - Culture 목록으로 리다이렉트)
  PATHFEED: '/community/kpathport/pathfeed',

  // 워크샵 목록 (카테고리별 고정 경로, 구 step01~05 대체)
  CULTURE: '/community/kpathport/culture',
  CAREER: '/community/kpathport/career',
  ETC: '/community/kpathport/etc',

  // 워크샵 (레거시 동적 경로 - 기존 링크 호환용)
  WORKSHOP_BASE: '/community/kpathport/workshop',
  WORKSHOP: (workshopId) => `/community/kpathport/workshop/${workshopId}`,

  // 예약 및 결제 플로우
  BOOKING: '/community/kpathport/booking',
  CHECK_DETAILS: '/community/kpathport/check-details',
  PAYMENTS: '/community/kpathport/payments',
  PAYMENT_SUCCESS: '/community/kpathport/payments/success',
  PAYMENT_FAIL: '/community/kpathport/payments/fail',
  CONFIRMED: '/community/kpathport/confirmed',
};

/**
 * 경로 헬퍼 함수
 */
export const getWorkshopPath = (workshopId) => {
  return KPATHPORT_ROUTES.WORKSHOP(workshopId);
};

export const getCheckDetailsPath = (cartItemIds) => {
  if (!cartItemIds || cartItemIds.length === 0) {
    return KPATHPORT_ROUTES.CHECK_DETAILS;
  }
  const ids = Array.isArray(cartItemIds) ? cartItemIds.join(',') : cartItemIds;
  return `${KPATHPORT_ROUTES.CHECK_DETAILS}?cartItemIds=${ids}`;
};

export const getPaymentsPath = (cartItemIds, bookingId) => {
  if (bookingId) {
    return `${KPATHPORT_ROUTES.PAYMENTS}?bookingId=${bookingId}`;
  }
  if (cartItemIds && cartItemIds.length > 0) {
    const ids = Array.isArray(cartItemIds) ? cartItemIds.join(',') : cartItemIds;
    return `${KPATHPORT_ROUTES.PAYMENTS}?cartItemIds=${ids}`;
  }
  return KPATHPORT_ROUTES.PAYMENTS;
};

export const getConfirmedPath = (orderId) => {
  if (!orderId) {
    return KPATHPORT_ROUTES.CONFIRMED;
  }
  return `${KPATHPORT_ROUTES.CONFIRMED}?orderId=${orderId}`;
};

